import React from 'react'
import {
  CheckoutSuccessDescription,
  CheckoutSuccessIconWrapper,
  CheckoutSuccessStyled,
  CheckoutSuccessTitle,
} from 'Features/checkout/components/CheckoutSuccess/CheckoutSuccess.styled'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleCheck } from '@fortawesome/pro-light-svg-icons'
import { useTranslation } from 'react-i18next'
import { IconProp } from '@fortawesome/fontawesome-svg-core'

export const CheckoutSuccess = ({ isSignUp }: { isSignUp?: boolean }) => {
  const { t } = useTranslation('checkout')
  return (
    <CheckoutSuccessStyled>
      <CheckoutSuccessIconWrapper isSignUp={isSignUp}>
        <FontAwesomeIcon
          style={{ width: '20px', height: '20px' }}
          icon={faCircleCheck as IconProp}
        />
      </CheckoutSuccessIconWrapper>
      <CheckoutSuccessTitle>{t('success')}</CheckoutSuccessTitle>
      <CheckoutSuccessDescription>{t('we_are_redirecting')}</CheckoutSuccessDescription>
    </CheckoutSuccessStyled>
  )
}
